<ngx-ui-loader />
<ng-container *ngIf="isLoggedIn()">
    <nav-strip />
    <div class="main-content" *ngIf="isOpsCompleted">
        <mat-sidenav-container [hasBackdrop]="false" [autosize]="true">
            <mat-sidenav #drawer [mode]="'side'" [opened]="true">
                <custom-side-nav></custom-side-nav>
            </mat-sidenav>
            <mat-sidenav-content>
                <toolbar />
                <div class="pages">
                    <router-outlet></router-outlet>
                </div>
            </mat-sidenav-content>
        </mat-sidenav-container>
    </div>
</ng-container>